module.exports = __webpack_public_path__ + "static/media/notification.0690551.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/notification.wav
// module id = d1z1
// module chunks = 31